module.exports = __webpack_public_path__ + "img/Lavender_Logo_RGB.25edf31c.png";